var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scroll_bar",style:(("transform: scaleY(" + (this.scale) + ");"))})}
var staticRenderFns = []

export { render, staticRenderFns }